(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-banner"]) return;
  try {
    
  class CategoryBannerSummary extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector('[data-summary-preview]');
      this.excerpt = this.querySelector('[data-summary-excerpt]');
      this.content = this.querySelector('[data-summary-content]');
      this.toggleButton = this.querySelector('[data-summary-toggle]');
      this.fullText = this.excerpt?.textContent.trim();

      if (!this.preview || !this.excerpt || !this.content || !this.toggleButton || !this.fullText) return;

      this.toggleButton.addEventListener('click', this.expand);
      this.resizeObserver = new ResizeObserver(this.scheduleMeasurement);
      this.resizeObserver.observe(this);
      this.scheduleMeasurement();

      document.fonts?.ready.then(this.scheduleMeasurement);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.expand);
      this.resizeObserver?.disconnect();

      if (this.measurementFrame) {
        cancelAnimationFrame(this.measurementFrame);
      }
    }

    scheduleMeasurement = () => {
      if (this.isExpanded) return;
      if (this.measurementFrame) cancelAnimationFrame(this.measurementFrame);

      this.measurementFrame = requestAnimationFrame(() => {
        this.measure();
        this.measurementFrame = undefined;
      });
    };

    measure = () => {
      this.excerpt.textContent = this.fullText;
      this.toggleButton.hidden = true;

      const lineHeight = Number.parseFloat(getComputedStyle(this.preview).lineHeight);
      const maximumHeight = lineHeight * 2 + 1;
      const isOverflowing = this.preview.scrollHeight > maximumHeight;

      if (!isOverflowing) return;

      this.toggleButton.hidden = false;
      const words = this.fullText.split(/\s+/);
      let lowerBound = 1;
      let upperBound = words.length;
      let visibleWordCount = 1;

      while (lowerBound <= upperBound) {
        const wordCount = Math.floor((lowerBound + upperBound) / 2);
        this.excerpt.textContent = words.slice(0, wordCount).join(' ');

        if (this.preview.scrollHeight <= maximumHeight) {
          visibleWordCount = wordCount;
          lowerBound = wordCount + 1;
        } else {
          upperBound = wordCount - 1;
        }
      }

      this.excerpt.textContent = words.slice(0, visibleWordCount).join(' ');
    };

    expand = () => {
      this.isExpanded = true;
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.resizeObserver?.disconnect();
      this.preview.remove();
      this.content.classList.remove('category-banner__summary-content--hidden');
      this.content.focus({ preventScroll: true });
    };
  }

  if (!customElements.get('category-banner-summary')) {
    customElements.define('category-banner-summary', CategoryBannerSummary);
  }

  } catch(e) { console.error(e); }
})();
})();
